import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useRef,
} from "react";
import { useLocation } from "react-router-dom";

interface SearchContextType {
  searchValue: string;
  setSearchValue: (value: string) => void;
  searchInputRef: React.RefObject<HTMLInputElement>;
}

const SearchContext = createContext<SearchContextType | undefined>(undefined);

interface SearchProviderProps {
  children: ReactNode;
}

export const SearchProvider: React.FC<SearchProviderProps> = ({ children }) => {
  const location = useLocation();
  const searchInputRef = useRef<HTMLInputElement>(null);

  const [searchValue, setSearchValue] = useState(() => {
    return new URLSearchParams(location.search).get("q") || "";
  });

  return (
    <SearchContext.Provider
      value={{ searchValue, setSearchValue, searchInputRef }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (context === undefined) {
    throw new Error("useSearch must be used within a SearchProvider");
  }
  return context;
};
